(function (window, document) {
  'use strict';

  if (window.__amicoOpenAICapiLoaded) return;
  window.__amicoOpenAICapiLoaded = true;

  var config = window.AMICO_OPENAI_CAPI_CONFIG || window.__AMICO_OPENAI_CAPI || {};
  var endpoint = typeof config.endpoint === 'string' ? config.endpoint : '';
  var token = typeof config.publicToken === 'string'
    ? config.publicToken
    : (typeof config.ingestionToken === 'string' ? config.ingestionToken : '');
  var tokenHeader = typeof config.tokenHeader === 'string' && config.tokenHeader
    ? config.tokenHeader
    : (typeof config.ingestionTokenHeader === 'string' && config.ingestionTokenHeader
      ? config.ingestionTokenHeader
      : 'X-OpenAI-Ads-Ingestion-Token');

  var OPPREF_KEY = 'amico_openai_oppref_v1';
  var OPPREF_MAX_AGE = 30 * 24 * 60 * 60 * 1000;
  var PENDING_LEAD_KEY = 'amico_openai_pending_lead_v3';
  var PENDING_REGISTRATION_KEY = 'amico_openai_pending_registration_v1';
  var PENDING_MAX_AGE = 30 * 60 * 1000;
  var MAX_SUCCESS_CHECKS = 10;
  var SUCCESS_CHECK_INTERVAL = 500;
  var leadSendInProgress = false;
  var registrationSendInProgress = false;

  var eligibleContactReasons = [
    'Project / Bulk Quote',
    'Distributor / Wholesale Inquiry',
    'Product Recommendation'
  ];

  function randomId(prefix) {
    var suffix = window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : Date.now() + '-' + Math.random().toString(36).slice(2);
    return prefix + '-' + suffix;
  }

  function safeSessionGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (_) { return null; }
  }

  function safeSessionSet(key, value) {
    try { window.sessionStorage.setItem(key, value); return true; } catch (_) { return false; }
  }

  function safeSessionRemove(key) {
    try { window.sessionStorage.removeItem(key); } catch (_) {}
  }

  function safeLocalGet(key) {
    try { return window.localStorage.getItem(key); } catch (_) { return null; }
  }

  function safeLocalSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (_) {}
  }

  function safeLocalRemove(key) {
    try { window.localStorage.removeItem(key); } catch (_) {}
  }

  function measurementAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var analyticsAllowed = null;
    var marketingAllowed = null;

    if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
      try { analyticsAllowed = privacy.analyticsProcessingAllowed(); } catch (_) { analyticsAllowed = null; }
    }
    if (privacy && typeof privacy.marketingAllowed === 'function') {
      try { marketingAllowed = privacy.marketingAllowed(); } catch (_) { marketingAllowed = null; }
    }
    if (privacy && typeof privacy.currentVisitorConsent === 'function') {
      try {
        var consent = privacy.currentVisitorConsent();
        if (analyticsAllowed === null && consent && (consent.analytics === true || consent.analytics === 'yes')) analyticsAllowed = true;
        if (analyticsAllowed === null && consent && (consent.analytics === false || consent.analytics === 'no')) analyticsAllowed = false;
        if (marketingAllowed === null && consent && (consent.marketing === true || consent.marketing === 'yes')) marketingAllowed = true;
        if (marketingAllowed === null && consent && (consent.marketing === false || consent.marketing === 'no')) marketingAllowed = false;
      } catch (_) {}
    }

    if (analyticsAllowed === false || marketingAllowed === false) return false;
    if (analyticsAllowed === true && marketingAllowed === true) return true;
    return config.measurementConsent === true;
  }

  function saveOppref() {
    if (!measurementAllowed()) return;
    try {
      var value = new URLSearchParams(window.location.search).get('oppref');
      if (value) safeLocalSet(OPPREF_KEY, JSON.stringify({ value: value, savedAt: Date.now() }));
    } catch (_) {}
  }

  function readOppref() {
    try {
      var queryValue = new URLSearchParams(window.location.search).get('oppref');
      if (queryValue) return queryValue;
    } catch (_) {}

    var raw = safeLocalGet(OPPREF_KEY);
    if (!raw) return '';
    try {
      var record = JSON.parse(raw);
      if (!record || !record.value || !record.savedAt || Date.now() - record.savedAt > OPPREF_MAX_AGE) {
        safeLocalRemove(OPPREF_KEY);
        return '';
      }
      return String(record.value);
    } catch (_) {
      safeLocalRemove(OPPREF_KEY);
      return '';
    }
  }

  function sourceUrl() {
    return String(window.location.href || '').slice(0, 2048);
  }

  function cleanData(value, depth) {
    if (depth > 2 || value === null || value === undefined) return value;
    if (typeof value === 'string') return value.slice(0, 256);
    if (typeof value === 'number' || typeof value === 'boolean') return value;
    if (Array.isArray(value)) return value.slice(0, 20).map(function (item) { return cleanData(item, depth + 1); });
    if (typeof value === 'object') {
      var result = {};
      Object.keys(value).slice(0, 30).forEach(function (key) {
        if (/^(email|phone|password|token|secret)$/i.test(key)) return;
        result[key.slice(0, 64)] = cleanData(value[key], depth + 1);
      });
      return result;
    }
    return undefined;
  }

  function send(type, data, customEventName, options) {
    if (!endpoint || !token || !measurementAllowed()) return Promise.resolve(false);
    if (type === 'custom' && !customEventName) return Promise.resolve(false);

    options = options || {};
    var event = {
      id: options.eventId || randomId('shopify'),
      type: type,
      timestamp_ms: Date.now(),
      source_url: options.sourceUrl || sourceUrl(),
      action_source: 'web',
      data: cleanData(data || { type: type === 'custom' ? 'custom' : 'contents' }, 0)
    };
    if (customEventName) event.custom_event_name = customEventName;

    var attribution = options.oppref || readOppref();
    if (attribution) event.oppref = String(attribution).slice(0, 512);

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        [tokenHeader]: token
      },
      body: JSON.stringify({ events: [event], measurement_consent: true }),
      credentials: 'omit',
      keepalive: true
    }).then(function (response) {
      return response.ok;
    }).catch(function () {
      return false;
    });
  }

  function usesThemeStandardEvents() {
    return config.standardEventsSource === 'theme';
  }

  function safePositiveInteger(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) && number > 0 ? Math.floor(number) : fallback;
  }

  function stringValue(value, fallback) {
    if (value === null || value === undefined || value === '') return fallback || '';
    return String(value).slice(0, 256);
  }

  function pageContext() {
    return config.pageContext && typeof config.pageContext === 'object' ? config.pageContext : {};
  }

  function contentItem(id, name, contentType, quantity) {
    return {
      id: stringValue(id, 'page:' + String(window.location.pathname || '/')),
      name: stringValue(name, document.title || ''),
      content_type: stringValue(contentType, 'page'),
      quantity: safePositiveInteger(quantity, 1)
    };
  }

  function currentPageContent() {
    var context = pageContext();
    var resource = context.resource && typeof context.resource === 'object' ? context.resource : null;
    return contentItem(
      resource && resource.id,
      resource && resource.name,
      resource && resource.contentType,
      1
    );
  }

  function trackInitialStandardEvents() {
    if (!usesThemeStandardEvents()) return;

    var item = currentPageContent();
    send('page_viewed', { type: 'contents', contents: [item] });

    var resource = pageContext().resource;
    if (resource && resource.id && (resource.contentType === 'product' || resource.contentType === 'collection')) {
      send('contents_viewed', { type: 'contents', contents: [item] });
    }
  }

  function addedCartItem(event) {
    var detail = event && event.detail ? event.detail : {};
    var item = detail.product || detail.item || detail;
    if (Array.isArray(item)) item = item[0];
    if (!item || typeof item !== 'object') return null;

    var id = item.variant_id || item.id || item.product_id;
    if (!id) return null;
    return contentItem(
      id,
      item.product_title || item.product_name || item.title || item.name,
      'product',
      item.quantity
    );
  }

  function visibleElement(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  }

  function visible(selector) {
    return visibleElement(document.querySelector(selector));
  }

  function safeReadJson(key) {
    var raw = safeSessionGet(key);
    if (!raw) return null;
    try {
      var value = JSON.parse(raw);
      if (!value || !value.createdAt || Date.now() - value.createdAt > PENDING_MAX_AGE) {
        safeSessionRemove(key);
        return null;
      }
      return value;
    } catch (_) {
      safeSessionRemove(key);
      return null;
    }
  }

  function leadFormInfo(form) {
    if (!form || form.tagName !== 'FORM') return null;
    if (form.matches('#BulkRequestForm')) {
      return { kind: 'bulk_sales', success: '#BulkRequestForm .form-success', error: '#BulkRequestForm .form-errors' };
    }
    if (form.matches('#pdp-quote-contact-form')) {
      return { kind: 'product_quote', success: '#pdp-quote-contact-form .pdp-form-success', error: '#pdp-quote-contact-form .pdp-form-error' };
    }
    if (form.matches('#kitform')) {
      return { kind: 'trade_kit', success: '#thanks', error: '#formerr' };
    }
    if (form.closest('.section-contact-form')) {
      var reasonField = form.querySelector('select[name="contact[How can we help you?]"]');
      var reason = reasonField ? String(reasonField.value || '') : '';
      var contactForms = document.querySelectorAll('.section-contact-form form');
      return {
        kind: 'contact_us',
        eligible: eligibleContactReasons.indexOf(reason) !== -1,
        reason: reason,
        formIndex: Array.prototype.indexOf.call(contactForms, form),
        success: '.form-notification.success',
        error: '.form-notification.error'
      };
    }
    return null;
  }

  function isRegistrationForm(form) {
    return Boolean(form && form.tagName === 'FORM' && form.id === 'AmicoCustomerRegisterForm');
  }

  function rememberLead(info) {
    if (!info || info.eligible === false || !measurementAllowed()) return;
    safeSessionSet(PENDING_LEAD_KEY, JSON.stringify({
      eventId: randomId('shopify-lead'),
      kind: info.kind,
      formIndex: Number.isInteger(info.formIndex) ? info.formIndex : null,
      sourceUrl: sourceUrl(),
      oppref: readOppref(),
      success: info.success,
      error: info.error,
      createdAt: Date.now()
    }));
  }

  function rememberRegistration() {
    if (!measurementAllowed()) return;
    safeSessionSet(PENDING_REGISTRATION_KEY, JSON.stringify({
      eventId: randomId('shopify-registration'),
      sourceUrl: sourceUrl(),
      oppref: readOppref(),
      createdAt: Date.now()
    }));
  }

  function markerVisible(pending, marker) {
    if (pending.kind !== 'contact_us') return visible(pending[marker]);
    var forms = document.querySelectorAll('.section-contact-form form');
    var form = forms[pending.formIndex];
    return Boolean(form && visibleElement(form.querySelector(pending[marker])));
  }

  function registrationSucceeded() {
    var path = String(window.location.pathname || '').replace(/\/+$/, '');
    return path === '/account' && document.body.classList.contains('customer-logged-in');
  }

  function registrationFailed() {
    return Boolean(document.querySelector('#AmicoCustomerRegisterForm .form-notification.error'));
  }

  function queuePendingCheck(tracker, delay, attempt) {
    if (tracker.timer !== null) return;
    tracker.timer = window.setTimeout(function () {
      tracker.timer = null;
      checkPendingEvent(tracker, attempt || 0);
    }, delay);
  }

  function checkPendingEvent(tracker, attempt) {
    var pending = safeReadJson(tracker.key);
    if (!pending || tracker.isSending()) return;
    if (tracker.error(pending)) {
      safeSessionRemove(tracker.key);
      return;
    }
    if (!tracker.success(pending)) {
      if (attempt < MAX_SUCCESS_CHECKS) queuePendingCheck(tracker, SUCCESS_CHECK_INTERVAL, attempt + 1);
      return;
    }

    tracker.setSending(true);
    send(tracker.eventType, { type: 'customer_action' }, null, {
      eventId: pending.eventId,
      sourceUrl: pending.sourceUrl,
      oppref: pending.oppref
    }).then(function (ok) {
      tracker.setSending(false);
      if (ok) safeSessionRemove(tracker.key);
    });
  }

  var leadTracker = {
    key: PENDING_LEAD_KEY,
    eventType: 'lead_created',
    timer: null,
    isSending: function () { return leadSendInProgress; },
    setSending: function (value) { leadSendInProgress = value; },
    success: function (pending) { return markerVisible(pending, 'success'); },
    error: function (pending) { return pending.error && markerVisible(pending, 'error'); }
  };

  var registrationTracker = {
    key: PENDING_REGISTRATION_KEY,
    eventType: 'registration_completed',
    timer: null,
    isSending: function () { return registrationSendInProgress; },
    setSending: function (value) { registrationSendInProgress = value; },
    success: function () { return registrationSucceeded(); },
    error: function () { return registrationFailed(); }
  };

  function panelName(panel) {
    if (!panel) return 'unknown';
    return String(panel.id || panel.className || panel.tagName || 'unknown').slice(0, 128);
  }

  function formName(form) {
    if (!form) return 'unknown';
    return String(form.id || form.getAttribute('name') || form.className || 'form').slice(0, 128);
  }

  function initialize() {
    saveOppref();
    trackInitialStandardEvents();

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) trackInitialStandardEvents();
    });

    document.addEventListener('cart:item-added', function (event) {
      if (!usesThemeStandardEvents()) return;
      var item = addedCartItem(event);
      if (item) send('items_added', { type: 'contents', contents: [item] });
    });

    document.addEventListener('cart-drawer:open', function () {
      send('custom', { type: 'custom', source: 'theme' }, 'cart_opened');
    });

    document.addEventListener('quick-view:open', function (event) {
      var detail = event.detail || {};
      send('custom', {
        type: 'custom',
        product_handle: detail.productHandle || '',
        product_path: String(detail.productUrl || '').split(/[?#]/)[0].slice(0, 256)
      }, 'quick_view_opened');
    });

    document.addEventListener('panel:open', function (event) {
      send('custom', { type: 'custom', panel_type: panelName(event.detail && event.detail.panel) }, 'panel_opened');
    });

    document.addEventListener('line-item:change:end', function (event) {
      send('custom', { type: 'custom', quantity: Number((event.detail && event.detail.quantity) || 0) }, 'cart_quantity_changed');
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;

      var info = leadFormInfo(form);
      if (isRegistrationForm(form)) {
        send('custom', { type: 'custom', form_id: formName(form) }, 'form_started');
        rememberRegistration();
        queuePendingCheck(registrationTracker, 0, 0);
        return;
      }

      if (!info || info.eligible === false) return;
      send('custom', { type: 'custom', form_id: formName(form) }, 'form_started');
      rememberLead(info);
      queuePendingCheck(leadTracker, info.kind === 'trade_kit' ? 0 : 250, 0);
    }, true);

    document.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a,button') : null;
      if (!link) return;
      var href = link.getAttribute('href') || '';

      if (/^mailto:/i.test(href) || /^tel:/i.test(href) || /wa\.me|whatsapp/i.test(href)) {
        var channel = /^mailto:/i.test(href) ? 'email' : (/^tel:/i.test(href) ? 'phone' : 'whatsapp');
        send('custom', { type: 'custom', channel: channel }, 'contact_link_clicked');
        return;
      }
      if (/\.(pdf|docx?|xlsx?|zip)(?:$|[?#])/i.test(href)) {
        send('custom', { type: 'custom', href: href.split(/[?#]/)[0].slice(0, 256) }, 'document_downloaded');
        return;
      }
      if (link.matches('[href*="bulk" i], [href*="quote" i], [href*="trade-kit" i], [data-b2b-cta], #pdp-quote-trigger, .amico-bulk-sales a[href="#form"], #amico-trade a[href="#apply"]')) {
        var text = (link.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 120);
        send('custom', {
          type: 'custom',
          cta_id: link.id || link.getAttribute('data-b2b-cta') || '',
          href: href.split(/[?#]/)[0].slice(0, 256),
          label: text
        }, 'b2b_cta_clicked');
      }
    }, true);

    var tradeRoot = document.querySelector('#amico-trade');
    if (tradeRoot && window.MutationObserver) {
      var completedSteps = {};
      var processStep = function (step) {
        var stepId = step.id || '';
        if (!stepId || completedSteps[stepId] || !step.classList.contains('on')) return;
        completedSteps[stepId] = true;
        send('custom', { type: 'custom', step: stepId.replace(/^step/, '') }, 'trade_kit_step_completed');
      };
      var observer = new MutationObserver(function (records) {
        records.forEach(function (record) {
          if (record.type === 'attributes' && record.attributeName === 'class' && record.target.matches('.step')) {
            processStep(record.target);
          }
        });
      });
      observer.observe(tradeRoot, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    window.setTimeout(function () {
      queuePendingCheck(leadTracker, 0, 0);
      queuePendingCheck(registrationTracker, 0, 0);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})(window, document);
